import { ListCategoriesResponseDataType } from "@@types/ICategory";
import { ListFormatsResponseDataType } from "@@types/IFormat";
import { api } from "@services/apiClient";
import { membersApi } from "@services/apiMembersClient";
import { GetProductParams } from "@_types/product/Product.types";
import {
  CreateProductInput,
  CreateProductOutput,
  GetProductInput,
  GetProductOutput,
  GetProductsSoldByCompanyOutput,
  GetProductStatisticsOutput,
  ListProductOutput,
  OrderbumpOutputType,
} from "@_types/product/Product.use-cases";
import { ResponsePaginationType, ResponseType } from "@_types/shared";

export async function getProductByUuid({ uuid }: GetProductInput): Promise<GetProductOutput> {
  return await api.get(`/products/${uuid}`, {}).then(response => response.data);
}

export async function getProducts(params: GetProductParams) {
  const status = params?.status;
  const statusString = status ? status.join(",") : undefined;
  const type = params?.format;
  const typeString = type ? type.join(",") : undefined;
  const finalParams = params ? { ...params, status: statusString, format: typeString } : undefined;

  return await api.get<ResponsePaginationType<ListProductOutput>>("/products", { params: finalParams });
}

export async function createProduct(data: CreateProductInput) {
  return await api.post<CreateProductOutput>("/products", data);
}

export async function getProductFormats() {
  return await api.get<ListFormatsResponseDataType>("/formats", { params: { page: 1, pageSize: 99 } });
}

export async function getProductCategories() {
  return await api.get<ListCategoriesResponseDataType>("/categories", { params: { page: 1, pageSize: 99 } });
}

export async function getProductStatisticsByUuid({ uuid }: GetProductInput) {
  return await api.get<GetProductStatisticsOutput>(`/products/${uuid}/statists`);
}

export async function getAvailableOrderbumps(productUuid: string, pageSize?: number) {
  const params = { pageSize: pageSize ?? 10 };
  return await api.get<ResponsePaginationType<OrderbumpOutputType>>(`/products/${productUuid}/available-order-bumps`, {
    params,
  });
}

export async function getCourseCreationStatus() {
  return await membersApi.get("");
}

export async function fetchProductsSoldByCompany() {
  return await api.get<ResponseType<GetProductsSoldByCompanyOutput>>("/products/sold-by-company");
}
